export enum PersonalInfoFieldTypeEnum {
    Text = 0,
    MaskedText = 1,
    DateTime = 2,
    PhoneNumber = 3,
}
